// Grade-policy rules for the employee's Financial Details (Add Employee / Employee 360) — the port of Stephanet's custom/gradePolicy.js.
// `setup` comes from GET /payroll/grade-setup (Payroll › Grade Policy Setup). The HR record holds names / codes: job_family, job_position,
// pay_grade.

export const familyOf = (setup, name) => setup?.families.find(f => f.name === name) || null;
export const positionOf = (setup, familyName, name) => {
  const fam = familyOf(setup, familyName);
  return setup?.positions.find(p => p.name === name && (!fam || p.family_id === fam.id)) || null;
};
export const gradeOf = (setup, code) => setup?.grades.find(g => g.code === code) || null;

export function eligibilityFor(setup, d) {
  const pos = positionOf(setup, d.job_family, d.job_position);
  if (!setup || !pos || !d.employee_category) return null;
  return setup.eligibility.find(e => e.active && e.employee_category === d.employee_category && e.position_id === pos.id) || null;
}

const level = (setup, id) => setup.grades.find(g => g.id === id)?.level;

// the grades the policy allows, by level (null when there is no policy for this category + position)
export function allowedGrades(setup, rule) {
  if (!setup || !rule) return null;
  const lo = level(setup, rule.min_grade_id), hi = level(setup, rule.max_grade_id);
  return setup.grades.filter(g => g.level !== null && g.level !== undefined && g.level >= lo && g.level <= hi);
}

// why the chosen grade is outside the policy, or ''
export function outsidePolicy(setup, d) {
  const rule = eligibilityFor(setup, d);
  const allowed = allowedGrades(setup, rule);
  if (!allowed || !d.pay_grade || allowed.some(g => g.code === d.pay_grade)) return '';
  return `${d.pay_grade} is outside ${rule.min_grade}–${rule.max_grade}, the grades allowed for ${d.employee_category} · ${d.job_position}`;
}

// the benefit table: the family's rule beats the rule for all families; a "from grade level" rule makes lower grades Not Eligible
export function benefitRows(setup, d) {
  if (!setup) return [];
  const fam = familyOf(setup, d.job_family);
  const lvl = gradeOf(setup, d.pay_grade)?.level;
  return setup.targets.map(t => {
    const rules = setup.rules.filter(r => String(r.target_id) === t.value);
    const rule = rules.find(r => fam && r.family_id === fam.id) || rules.find(r => !r.family_id);
    const benefit = t.label;
    if (!rule) return { benefit, status: 'Eligible', note: '' };
    if (rule.min_grade_level && (!lvl || lvl < rule.min_grade_level)) {
      return { benefit, status: rule.status === 'Eligible' ? 'Not Eligible' : rule.status, note: rule.note || `Grade level ${rule.min_grade_level}+ only.` };
    }
    return { benefit, status: rule.status, note: rule.note || '' };
  });
}
